import BlockIcon from "@mui/icons-material/Block";
import { Box, Paper, Typography, Button } from "@mui/material";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export function AssinaturasAccessDenied(): React.ReactElement {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "60vh",
      }}
    >
      <Paper
        sx={{
          p: 5,
          textAlign: "center",
          maxWidth: 480,
          borderRadius: 3,
          boxShadow: 3,
        }}
      >
        <Box sx={{ color: "#ef4444", mb: 2 }}>
          <BlockIcon sx={{ fontSize: 64 }} />
        </Box>
        <Typography color="#1e293b" fontWeight="bold" gutterBottom variant="h5">
          {t("assinaturas.accessDenied.title")}
        </Typography>
        <Typography color="text.secondary" paragraph variant="body1">
          {t("assinaturas.accessDenied.message")}
        </Typography>
        <Button
          onClick={() => { navigate("/assinaturas"); }}
          sx={{ mt: 2, bgcolor: "#2F16C9", fontWeight: "bold", "&:hover": { bgcolor: "#0C1C69" } }}
          variant="contained"
        >
          {t("assinaturas.accessDenied.back")}
        </Button>
      </Paper>
    </Box>
  );
};

export default AssinaturasAccessDenied;
